import { useMutation } from '@tanstack/react-query'
import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'

export const changePaymentMethod = (data: object) => {
  return axios.put(endpoints.changePaymentMethod, data)
}

export const useChangePaymentMethod = () => {
  return useMutation(changePaymentMethod)
}
